import React from "react";
import config from "./../../../config/config";

const Metodos =( props) => {
    let {className} = props;
    return(
        <div className={`${className}wc f01 metodosIcons `}>
            <img src={config.pagosProcesadosEpaycoLogo} alt="logo-epayco" style={{ maxHeight: "20px" }} />
        </div>
    )
}

export default Metodos;
